import type { PilnoscAlertu, RodzajSerwisu, StatusObszaru, StatusSerwisu, StatusSpisu } from '../api/typy';

export const RODZAJ_SERWISU: Record<RodzajSerwisu, string> = {
  PRZEGLAD: 'przegląd okresowy',
  KALIBRACJA: 'kalibracja',
  NAPRAWA: 'naprawa',
  WYMIANA_AKUMULATORA: 'wymiana akumulatora',
  AKTUALIZACJA_OPROGRAMOWANIA: 'aktualizacja oprogramowania',
  INNE: 'inne',
};

export const STATUS_SERWISU: Record<StatusSerwisu, { etykieta: string; ton: 'ok' | 'uwaga' | 'blad' | 'neutralny' }> = {
  ZAPLANOWANY: { etykieta: 'zaplanowany', ton: 'neutralny' },
  W_TRAKCIE: { etykieta: 'w trakcie', ton: 'uwaga' },
  ZAKONCZONY: { etykieta: 'zakończony', ton: 'ok' },
  ANULOWANY: { etykieta: 'anulowany', ton: 'neutralny' },
};

export const PILNOSC: Record<PilnoscAlertu, { etykieta: string; ton: 'ok' | 'uwaga' | 'blad' | 'neutralny'; klasa: string }> = {
  ZALEGLY: { etykieta: 'termin minął', ton: 'blad', klasa: 'text-status-brak' },
  PILNY: { etykieta: 'pilne', ton: 'blad', klasa: 'text-status-brak' },
  BLISKI: { etykieta: 'wkrótce', ton: 'uwaga', klasa: 'text-status-uzupelnij' },
  ODLEGLY: { etykieta: 'na horyzoncie', ton: 'neutralny', klasa: 'text-kamien-600' },
};

export const RODZAJ_ALERTU: Record<'PRZEGLAD' | 'GWARANCJA' | 'TERMIN_WAZNOSCI', string> = {
  PRZEGLAD: 'przegląd',
  GWARANCJA: 'gwarancja',
  TERMIN_WAZNOSCI: 'termin ważności',
};

export const STATUS_SPISU: Record<StatusSpisu, { etykieta: string; ton: 'ok' | 'uwaga' | 'blad' | 'neutralny' }> = {
  OTWARTA: { etykieta: 'otwarta', ton: 'uwaga' },
  W_TRAKCIE: { etykieta: 'w trakcie', ton: 'uwaga' },
  ZAMKNIETA: { etykieta: 'zamknięta', ton: 'ok' },
  ANULOWANA: { etykieta: 'anulowana', ton: 'neutralny' },
};

export const STATUS_OBSZARU: Record<StatusObszaru, { etykieta: string; ton: 'ok' | 'uwaga' | 'blad' | 'neutralny' }> = {
  DO_SPISU: { etykieta: 'do spisania', ton: 'neutralny' },
  W_TRAKCIE: { etykieta: 'spisywana', ton: 'uwaga' },
  SPISANA: { etykieta: 'spisana', ton: 'ok' },
  ZATWIERDZONA: { etykieta: 'zatwierdzona', ton: 'ok' },
};
